<template>
  <div class="page full-page">
    <div class="map-container" ref="mapContainer"></div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data () {
    return {
      city: '',
      address: ''
    }
  },
  methods:{
    initMap (container) {
      let geocoder, map, marker = null
      let mapLatlng = new qq.maps.LatLng(39.916527, 116.397128)
      let mapOptions = {
        zoom: 18,
        center: mapLatlng,
        mapTypeId: qq.maps.MapTypeId.ROADMAP
      }
      map = new qq.maps.Map(container, mapOptions)

      geocoder = new qq.maps.Geocoder({
        complete : function(result){
          map.setCenter(result.detail.location)
          marker = new qq.maps.Marker({
            map: map,
            position: result.detail.location
          })
        }
      })

      geocoder.getLocation(this.city + this.address)
    }
  },
  mounted () {
    let mapContainer = this.$refs.mapContainer
    this.city = this.$route.query.city
    this.address = this.$route.query.address
    console.log(this.city + this.address)
    this.initMap(mapContainer)
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Map.vue